import { render, staticRenderFns } from "./ValidateFromLink.vue?vue&type=template&id=d5b07a48"
import script from "./ValidateFromLink.vue?vue&type=script&lang=js"
export * from "./ValidateFromLink.vue?vue&type=script&lang=js"
import style0 from "./ValidateFromLink.vue?vue&type=style&index=0&id=d5b07a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports